import { Modal } from "antd";
import { useEffect, useState } from "react";
import { KristiHBD } from "../../../assets/images";

const HappyBirthdayModal = ({ open, setOpen }) => {
  return null;
  const [showFireworks, setShowFireworks] = useState(false);

  useEffect(() => {
    if (open) {
      setShowFireworks(true);
      const timer = setTimeout(() => setShowFireworks(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [open]);

  const fireworkPoints = [
    { x: 20, y: 20 },
    { x: 80, y: 15 },
    { x: 15, y: 70 },
    { x: 85, y: 75 },
  ];

  return (
    <Modal
      className="happyBirthdayModal"
      open={open}
      onCancel={() => setOpen(false)}
      centered
      width={633}
      height={555}
      maskClosable={true}
      footer={null}
      style={{ position: "relative", overflow: "hidden" }}
    >
      <div onClick={() => setOpen(false)}>
        <img src={KristiHBD} alt="Happy Birthday" />

        {showFireworks &&
          fireworkPoints.map((point, fireworkIndex) => (
            <div key={fireworkIndex}>
              {Array.from({ length: 15 }).map((_, i) => {
                const duration = 1 + Math.random() * 4;
                const delay = fireworkIndex * 0.2;

                return (
                  <div
                    key={i}
                    style={{
                      position: "absolute",
                      top: `${point.y}%`,
                      left: `${point.x}%`,
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: [
                        "#FFD700",
                        "#FF6B6B",
                        "#4ECDC4",
                        "#45B7D1",
                        "#96CEB4",
                        "#FFEAA7",
                        "#DDA0DD",
                        "#FF7675",
                      ][i % 8],
                      boxShadow: `0 0 6px ${
                        [
                          "#FFD700",
                          "#FF6B6B",
                          "#4ECDC4",
                          "#45B7D1",
                          "#96CEB4",
                          "#FFEAA7",
                          "#DDA0DD",
                          "#FF7675",
                        ][i % 8]
                      }`,
                      transform: `translate(-50%, -50%)`,
                      transformOrigin: "center",
                      zIndex: 1000,
                      animation: `fireworkParticle-${fireworkIndex}-${i} ${duration}s ease-out ${delay}s forwards`,
                    }}
                  />
                );
              })}
            </div>
          ))}
      </div>

      <style>{`
        ${fireworkPoints
          .map((point, fireworkIndex) =>
            Array.from({ length: 15 })
              .map((_, i) => {
                const angle = (i * 360) / 15;
                const distance = 50 + Math.random() * 100;
                const radians = (angle * Math.PI) / 180;
                const endX = Math.cos(radians) * distance;
                const endY = Math.sin(radians) * distance;

                return `
              @keyframes fireworkParticle-${fireworkIndex}-${i} {
                0% {
                  transform: translate(-50%, -50%) scale(0);
                  opacity: 1;
                }
                10% {
                  transform: translate(-50%, -50%) scale(1);
                  opacity: 1;
                }
                100% {
                  transform: translate(
                    calc(-50% + ${endX}px), 
                    calc(-50% + ${endY}px)
                  ) scale(0);
                  opacity: 0;
                }
              }
            `;
              })
              .join("")
          )
          .join("")}
      `}</style>
    </Modal>
  );
};

export default HappyBirthdayModal;
